import { Box, Stack, Typography } from 'src/components/mui';
import { ResponsiveText } from '../../responsive-text/ResponsiveText';
import parse from 'html-react-parser';
import { responsiveTextParseOptions } from '../../responsive-text/config';

export const TitleAndDescription = ({
  title,
  description,
  isTextShadowed,
}: {
  title: string;
  description: string;
  isTextShadowed: boolean;
}) => {
  return (
    <Stack spacing={2} zIndex={999}>
      <ResponsiveText
        sx={{
          color: '#fff',
          textShadow: isTextShadowed
            ? '0px 0px 14px rgba(0, 0, 0, 0.57), 0px 0px 2px rgba(0, 0, 0, 0.7)'
            : 'none',
        }}
      >
        <Typography
          className="header2"
          sx={{
            fontSize: '2rem',
            display: '-webkit-box',
            '& p': {
              margin: 0,
            },
          }}
          lineClamp={3}
        >
          {parse(title, responsiveTextParseOptions)}
        </Typography>
      </ResponsiveText>

      <Box
        sx={{
          overflowY: 'unset',
        }}
        scrollbar="light"
      >
        <ResponsiveText
          sx={{
            color: '#fff',
            p: 1,
            textShadow: isTextShadowed
              ? '0px 0px 14px rgba(0, 0, 0, 0.57), 0px 0px 2px rgba(0, 0, 0, 0.7)'
              : 'none',
          }}
        >
          <Typography
            className="header5"
            sx={{
              fontSize: '1.25rem',
              '& p': {
                margin: 0,
              },
            }}
          >
            {parse(description, responsiveTextParseOptions)}
          </Typography>
        </ResponsiveText>
      </Box>
    </Stack>
  );
};
